import * as React from 'react';
import { Loading } from '../Loading';
import { debounce } from 'debounce';
import { style } from './style';
export class InfiniteScroll extends React.Component {
    constructor(props) {
        super(props);
        this.scrollElement = () => {
            if (!this.props.height) {
                return document;
            }
            return this.el;
        };
        this.onScroll = (data) => debounce((event) => {
            if (this.state.data.length >= this.props.count ||
                !this.isElementAtBottom(event.target) ||
                this.state.isLoading) {
                return;
            }
            this.setState({ isLoading: true });
            const d = [...this.state.data];
            data(this.state.pageNumber + 1).then((v) => this.setState({ data: d.concat(v), isLoading: false, pageNumber: this.state.pageNumber + 1 }));
        }, 200);
        this.initScrollEvent = () => {
            const { data } = this.props;
            const scrollElement = this.scrollElement();
            scrollElement.onscroll = this.onScroll(data);
        };
        this.state = {
            data: [],
            isLoading: true,
            pageNumber: 1,
        };
    }
    componentDidMount() {
        this.props.data(this.state.pageNumber).then((v) => this.setState({ data: v, isLoading: false }));
        this.initScrollEvent();
    }
    isElementAtBottom(target) {
        if (target === document) {
            return (Math.abs(window.innerHeight + window.pageYOffset - document.body.offsetHeight) <=
                (document.body.scrollHeight * 10) / 100);
        }
        return (Math.abs(target.scrollTop -
            (target.scrollHeight - target.offsetHeight)) <=
            (target.scrollHeight * 10) / 100);
    }
    render() {
        const { data, isLoading, pageNumber } = this.state;
        return (React.createElement(Container, Object.assign({}, this.props, { data: data, pageNumber: pageNumber, isLoading: isLoading, element: (el) => (this.el = el) })));
    }
}
InfiniteScroll.defaultProps = {
    scrollElement: document,
    loading: React.createElement(Loading, { isLoading: true }),
};
const Container = (props) => {
    const { data, render, loading, isLoading, element, height } = props;
    const css = style(height);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css.container, ref: (el) => element(el) }, render(data)),
        React.createElement("div", { className: css.loadingContainer }, isLoading && React.createElement("div", { className: css.loadingIndicator }, loading))));
};
//# sourceMappingURL=InfiniteScroll.js.map